import { formatUtcTimestamp, getUtcTimestampMs, normalizeUtcTimestamp } from './utcDateTimes';

export const normalizeTranscriptTimestamp = (timestamp?: string | null): string => {
  return normalizeUtcTimestamp(timestamp);
};

export const getTranscriptTimestampMs = (timestamp?: string | null): number => {
  return getUtcTimestampMs(timestamp);
};

export const formatTranscriptTimestamp = (
  timestamp: string | null | undefined,
  format: string
): string => {
  return formatUtcTimestamp(timestamp, format);
};
